import styled from 'styled-components';

const Title = styled.div`
  font-size: var(--font-size-l);
  font-weight: 700;
  line-height: 1.25em;
  text-align: left;
`;

export default Title;
